import styled from '@emotion/styled';
import { IonLabel, IonNote } from '@ionic/react';

import { to } from '@/styles/breakpoints';

const StyledIonLabel = styled(IonLabel)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledIonNote = styled(IonNote)`
  ${to.md} {
    display: none;
  }
`;

export default {
  IonLabel: StyledIonLabel,
  IonNote: StyledIonNote,
};
